<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <div class="row" v-if="cards">
          <div class="col-md-4">
            <div class="form-group">
              <label>Карта для оплаты</label>
              <select class="form-control" v-model="selectedCardId">
                <option value="0">Выберите карту</option>
                <option v-for="(c, index) in cards" :key="index" :value="c.id">[{{c.id}}] {{ c.number }} ({{
                    c.balance || 0
                  }})
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-8">
            <div class="form-group">
              <label>Ссылка для оплаты</label>
              <div class="input-group">
                <input type="text" v-model="payLink" class="form-control">
                <div class="input-group-append">
                  <LoadingButton
                    title="Создать задачу"
                    :loading="btnLoading"
                    :color="$constants.PRIMARY_COLOR"
                    :onClick="() => createTask()"
                    className="btn btn-outline-info"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="text-right">
          <button @click="() => getRecords(1)" class="btn btn-sm btn-outline-success">Обновить задачи</button>
        </div>
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>

        <table class="table table-sm mt-1 table-hover" v-if="tasks && tasks.length">
          <thead>
          <tr>
            <th>№</th>
            <th>Счет</th>
            <th>Ответ</th>
            <th>Создание</th>
            <th>Статус</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(t, i) in tasks">
            <td>{{ (i + 1) + ((paginator.current_page - 1) * paginator.per_page) }}</td>
            <td>({{ t?.card?.id}}) {{ t?.card?.number }}</td>
            <td>
              <p v-if="t.task_data?.pay_link"><a :href="t.task_data.pay_link" target="_blank">Ссылка на оплату</a></p>
              <div v-html="t.task_data?.report"/>
            </td>
            <td>{{ printDate(t.created_at) }}</td>
            <td>
              <p><span
                :class="{'badge': true, 'badge-success': t.is_active, 'badge-dark': !t.is_active}">{{
                  t.is_active ? 'В работе' : 'Закрыта'
                }}</span>
              </p>
              <template v-if="!t.is_active">
                <LoadingButton
                  title="перезапустить"
                  :loading="taskBtnLoading[t.id]"
                  :color="$constants.PRIMARY_COLOR"
                  :onClick="() => activateTask(t.id)"
                  className="btn btn-xs btn-outline-info"
                />
              </template>
            </td>
          </tr>
          </tbody>
        </table>

        <div class="text-right">
          <paginate v-if="paginator"
                    :page-count="paginator.last_page"
                    :page-range="11"
                    :margin-pages="2"
                    v-model="paginator.current_page"
                    :click-handler="getRecords"
                    :prev-text="'&laquo'"
                    :next-text="'&raquo'"
                    :container-class="'pagination'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :active-class="'active green_btn'">
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import Paginate from 'vuejs-paginate'
import LoadingButton from "@/components/buttons/LoadingButton.vue";

export default {
  components: {
    Paginate,
    LoadingButton,
  },
  data() {
    return {
      selectedCardId: 0,
      payLink: null,
      cards: null,
      loading: false,
      btnLoading: false,
      taskBtnLoading: {},
      tasks: null,
      paginator: null,
      tasksType: 18,
      cardsType: 5
    }
  },
  created() {
    this.getCards();
    this.getRecords();
  },
  methods: {
    async activateTask(taskId) {
      this.taskBtnLoading[taskId] = true;
      this.taskBtnLoading = {...this.taskBtnLoading};
      const {data} = await api.post('/tasks/update', {
        type: 'activate',
        task_id: taskId
      });
      if (data.success) {
        const index = this.tasks.findIndex((t) => t.id === taskId);
        if (index !== -1) {
          this.tasks[index].is_active = 1;
        }
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.taskBtnLoading[taskId] = false;
    },
    async createTask() {
      if (!this.selectedCardId || !this.payLink) return;
      this.btnLoading = true;
      const {data} = await api.post('/tasks/new', {
        type: 'makeQiwiPayment',
        card_id: this.selectedCardId,
        pay_link: this.payLink,
      })
      if (data.success) {
        this.getRecords();
        this.selectedCardId = 0;
        this.payLink = null;
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.btnLoading = false;
    },
    async getCards() {
      const {data} = await api.index('/cards/getCards?typeId=' + this.cardsType);
      if (data.success) {
        this.cards = data.records;
      } else {
        toastr['warning'](data.message || 'Карты не загружены');
      }
    },
    async getRecords(page = 1) {
      this.loading = true;
      let {data: r_data} = await api.index('/tasks/type/' + this.tasksType + '?page=' + page);
      if (r_data.success) {
        const {data, ...pagination} = r_data.records;
        this.paginator = pagination;
        this.tasks = data;
      } else {
        toastr['warning'](r_data.message || 'Задач не найдено');
      }
      this.loading = false;
    }
  }
}

</script>
